import { api } from './api';

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class Register {
  static get BASE_PATH() {
    if (import.meta.client) {
      return [globalThis?.location?.origin || '', 'api/'].join('/');
    }
    return '';
  }

  static async register(payload: RegisterPayload, headers?: Record<string, any>) {
    const response = await api.post(`${Register.BASE_PATH}register`, payload, headers);
    return response;
  }
  
  static async registerAppToWeb(payload: RegisterAppToWebPayload, headers?: Record<string, any>) {
    const response = await api.post(`${Register.BASE_PATH}register/app-to-web`, payload, headers);
    return response;
  }

  static async sendOtp(headers?: Record<string, any>) {
    const response = await api.post(`${Register.BASE_PATH}register/send-otp`, undefined, headers);
    return response;
  }

  static async checkOtp(payload: { code: string }, headers?: Record<string, any>) {
    const response = await api.post(`${Register.BASE_PATH}register/check-otp`, payload, headers);
    return response;
  }
}

export default Register;
